const KEY = "pbo-contest-session-v1";

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const saveContestSession = (code, participantId, username) => {
  const data = readAll();
  data[code.toUpperCase()] = { participantId, username, savedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(data));
};

export const getContestSession = (code) => {
  const data = readAll();
  return data[code?.toUpperCase()] || null;
};

export const clearContestSession = (code) => {
  const data = readAll();
  delete data[code.toUpperCase()];
  localStorage.setItem(KEY, JSON.stringify(data));
};
